'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _reactIntl = require('react-intl');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ClickTracker = require('../../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeField = function (_React$Component) {
  (0, _inherits3.default)(TimeField, _React$Component);

  function TimeField(props) {
    (0, _classCallCheck3.default)(this, TimeField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TimeField.__proto__ || (0, _getPrototypeOf2.default)(TimeField)).call(this, props));

    _this.getIs24HourFormat = function () {
      var timeString = _this.formatTime((0, _moment2.default)()).toLowerCase();
      return !timeString.includes('a') && !timeString.includes('p') && !timeString.includes('m');
    };

    _this.handleChange = function (date) {
      (0, _ClickTracker.addEditTrack)(_this.getAutomationName());

      if (date && (typeof date === 'undefined' ? 'undefined' : (0, _typeof3.default)(date)) === "object") {
        _this.props.onChange(date.toISOString().split('.')[0] + 'Z');
      } else {
        _this.props.onChange(null);
      }
    };

    _this.formatTime = function (time) {
      var formatTime = _this.props.intl.formatTime;

      return formatTime(time, {
        hour: 'numeric',
        minute: 'numeric'
      });
    };

    _this.formatValue = function () {
      if ((0, _typeof3.default)(_this.props.value) === "object") {
        return _this.props.value;
      } else {
        var date = (0, _moment2.default)(_this.props.value);
        if (!date.isValid() || _this.props.value === undefined) {
          return null;
        } else {
          return date;
        }
      }
    };

    _this.getAutomationName = function () {
      return _AutomationName2.default.get('time', _this.props.automationName);
    };

    _this.state = {
      is24HourFormat: _this.getIs24HourFormat()
    };
    return _this;
  }

  /**
   * Determines if current locale is in 24 hour format
   * This is simply needed to exclude the automatic assumption
   * that hours 1-6 default to pm if not specified.
   * In 24 hour mode, we do not alter the input with any assumption
   */


  (0, _createClass3.default)(TimeField, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_cwUi.CwTimeField, (0, _assign2.default)({}, this.props, {
        cwId: this.getAutomationName(),
        onChange: this.props.onChange ? this.handleChange : undefined,
        formatTime: this.formatTime,
        value: this.formatValue(),
        is24HourFormat: this.state.is24HourFormat
      }));
    }
  }]);
  return TimeField;
}(_react2.default.Component);

TimeField.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string
}, _cwUi.CwTimeField.propTypes, {
  /**
   * Override required prop from spread, these props should never
   * be set set in this component above
   */
  formatTime: _propTypes2.default.func,
  value: _propTypes2.default.string
});

exports.default = (0, _reactIntl.injectIntl)(TimeField);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/timefield/TimeField.js
// module id = 796
// module chunks = 10